<div *ngIf="!!data">
    <div mat-dialog-content>
        <p *ngIf="data.reason">
           {{data.reason}}
        </p>
    </div>
</div>